// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-container{padding:15px;display:flex;flex-direction:column}.dp-header{font-size:20px;border-bottom:1px solid #ccc;margin-bottom:15px;padding-bottom:10px;font-weight:bold}", ""]);
// Exports
module.exports = exports;
